import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, FormGroup, Form, Button, Image, Container, FormControl } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import Swal from 'sweetalert2';
import Loading from '../Loading';
import {
    getBookingPaymentDetailsService,
    printSignedBookingService,
    applyBookingDiscountCodeService,
} from '../../services/bookingsService';
import { createTransactionService } from '../../services/transactionsService';
import {
    applyPortalTextColor,
    convertQueryStringToObject,
    formatCurrency,
    dispatchModal,
    formatToFixed,
    roundTo,
    normalizePaymentError,
    errorSwal,
} from '../../utils/helper';
import './index.scss';
import { makeBookingPortalPaymentService } from '../../services/paymentService';
import PayrocPaymentModal from '../PaymentFormSections/PayrocPaymentModal';
import FiservCardNumberField from '../FiservCardNumberField';
import { useFeatureToggle, FEATURE_TOGGLE_IDS } from '../../utils/hooks/useFeatureToggle';
let user = JSON.parse(localStorage.getItem('user'));

const ListVehicles = ({ price, quantity, description, tripSetting }) => {
    return (
        <Row noGutters>
            <Col xs={12}>
                <div className="booking-details">
                    <p className="booking-desc" style={{ color: `${tripSetting.textColor}` }}>
                        {description}
                    </p>
                    <div className="row">
                        <div className="col-7">
                            <p className="booking-qty">
                                QTY :<span className="portal-text"> {quantity ? quantity : 0}</span>
                            </p>
                        </div>
                        <div className="col-5 text-right">
                            <p className="booking-price">{`$${price ? formatCurrency(price) : '0.00'}`}</p>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

const ListAddons = ({ price, quantity, description, priceTypeId, tripSetting }) => {
    return (
        <Row noGutters>
            <Col xs={12}>
                <div className="booking-details">
                    <div className="row">
                        <div className="col-7">
                            <p className="booking-qty">
                                {priceTypeId === 3 || priceTypeId === 8 || priceTypeId === 9 ? (
                                    <span className="portal-text">{`${description} (${quantity ? quantity : 0})`}</span>
                                ) : (
                                    <span className="portal-text">{description}</span>
                                )}
                            </p>
                        </div>
                        <div className="col-5 text-right">
                            <p className="booking-price">{`$${price ? formatCurrency(price) : '0.00'}`}</p>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

const ListDiscountCodes = ({ displayName, amount }) => {
    return (
        <Row noGutters>
            <Col xs={12}>
                <div className="booking-details">
                    <div className="row">
                        <div className="col-7">
                            <p className="booking-qty">
                                <span className="text-gray-light">{displayName}</span>
                            </p>
                        </div>
                        <div className="col-5 text-right">
                            <p className="booking-price">{`-$${amount ? formatCurrency(amount) : '0.00'}`}</p>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

const BookingTransaction = (props) => {
    const queryObj = convertQueryStringToObject(window.location.search);
    const bookingId = queryObj.bid;
    const contarctId = queryObj.contarctId;
    const ts = queryObj.ts;

    const { register, handleSubmit } = useForm();
    const [initialLoading, setInitialLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [addonAssignments, setAddonAssignments] = useState([]);
    const [discountCodes, setDiscountcodes] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [bookingID, setBookingID] = useState('');
    const [bookingDetails, setBookingDetail] = useState({});
    const [tripSetting, setTripSetting] = useState({});
    const [filterByType, setFilterByType] = useState('payDeposit');
    const [formState, setFormState] = useState({ stage: 0, paymentType: '', amount: '', id: '' });
    const [paymentAmount, setPaymentAmount] = useState();
    const [totals, setTotals] = useState({
        vehiclesTax: null,
        addonsTax: null,
    });
    const [errors, setError] = useState([]);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [discountInput, setDiscountInput] = useState('');
    const [applyingDiscount, setApplyingDiscount] = useState(false);
    const [fiservToken, setFiservToken] = useState('');
    const [fiservError, setFiservError] = useState(null);
    const [fiservFieldKey, setFiservFieldKey] = useState(0);
    const fiservFieldRef = useRef(null);

    const isFiservHostedFieldsEnabled = useFeatureToggle(FEATURE_TOGGLE_IDS.FISERV_HOSTED_FIELDS);
    const fiservHostedFieldsActive = tripSetting?.paymentProcessorTypeID === 3 && isFiservHostedFieldsEnabled;

    // A charge consumes the token and the expiration/CVV bound to it, so any retry needs freshly entered card details
    const resetFiservCard = () => {
        setFiservToken('');
        setFiservError(null);
        setFiservFieldKey((key) => key + 1);
    };

    useEffect(() => {
        (async () => {
            try {
                setInitialLoading(true);
                let booking = await getBookingPaymentDetailsService(bookingId, ts);
                if (booking?.data?.details?.invoiceID) {
                    window.location.href = `${window.location.origin}/p/pay-invoice?ts=${booking?.data?.details?.invoiceTimeStamp}&invoiceId=${booking?.data?.details?.invoiceID}`;
                }

                if (booking && Object.keys(booking.data).length > 0) {
                    const bookingDataDetails = booking.data?.details;
                    setBookingDetail(bookingDataDetails);
                    setBookingID(bookingDataDetails.bookingId);

                    let states = booking.data?.states;
                    setStates(states);
                    let addonAssignment = booking.data?.addonData;
                    setAddonAssignments(addonAssignment);
                    let discountCode = booking.data?.discountCodeBookings;
                    setDiscountcodes(discountCode);
                    let vehicles = booking.data?.dispatches;
                    setVehicles(vehicles);
                    let tripSetting = booking.data?.accountSettings;
                    applyPortalTextColor(tripSetting?.portalTextColor);
                    setTripSetting(tripSetting);
                    let country = booking.data?.countries;
                    setCountries(country);

                    let addonsTax = Array.isArray(addonAssignment)
                        ? addonAssignment.reduce((sum, addon) => sum + Number(addon.tax), 0)
                        : 0;
                    let vehiclesTax = Array.isArray(vehicles)
                        ? vehicles.reduce((sum, dispatch) => sum + Number(dispatch.tax), 0)
                        : 0;
                    let addonsTotal = Array.isArray(addonAssignment)
                        ? addonAssignment.reduce((sum, addon) => sum + Number(addon.price), 0)
                        : 0;
                    let vehiclesTotal = Array.isArray(vehicles)
                        ? vehicles.reduce((sum, dispatch) => sum + Number(dispatch.price), 0)
                        : 0;
                    let discountsTotal = Array.isArray(discountCode)
                        ? discountCode.reduce((sum, discount) => sum + Number(discount.amount), 0)
                        : 0;
                    let subTotal = addonsTotal + vehiclesTotal - discountsTotal;
                    let surchargePercentage = bookingDataDetails.surchargePercentage;
                    let surchargeAmount = calculateSurchargeAmount(subTotal);
                    let tax = addonsTax + vehiclesTax;
                    let total = subTotal + tax;
                    let amountPaid = Number(bookingDetails.amountPaid);
                    let depositDueAmount = Number(bookingDetails.depositAmount) - Number(bookingDetails.amountPaid);
                    let finalPaymentDueAmount = Number(total) - Number(bookingDetails.amountPaid);
                    if (depositDueAmount <= 0) {
                        setFilterByType('payBalanceDue');
                        setPaymentAmount(total - amountPaid);
                    } else {
                        setPaymentAmount(depositDueAmount);
                    }

                    setTotals({
                        subTotal,
                        tax,
                        total,
                        depositDueAmount,
                        surchargeAmount,
                        surchargePercentage,
                        finalPaymentDueAmount,
                        amountPaid,
                        depositDue: bookingDetails.depositDue,
                        finalPaymentDue: bookingDetails.finalPaymentDue,
                        depositAmount: Number(bookingDetails.depositAmount),
                        vehiclesTax: formatToFixed(addonsTax),
                        addonsTax: formatToFixed(vehiclesTax),
                        vehiclesTotal: formatToFixed(addonsTotal),
                        addonsTotal: formatToFixed(vehiclesTotal),
                    });
                } else {
                    dispatchModal('Booking Record Not Found.');
                }
                setInitialLoading(false);
            } catch (e) {
                console.log('e', e);
                setInitialLoading(false);
                setLoading(false);
            }
        })();
    }, [
        bookingDetails.amountPaid,
        bookingDetails.depositAmount,
        bookingDetails.depositDue,
        bookingDetails.finalPaymentDue,
        bookingId,
        totals.amountPaid,
        totals.depositAmount,
    ]);

    const handleApplyDiscountCode = async () => {
        if (!discountInput.trim()) {
            return Swal.fire({ title: 'Error', text: 'Please enter a discount code', icon: 'error' });
        }
        try {
            setApplyingDiscount(true);
            const result = await applyBookingDiscountCodeService(bookingId, discountInput.trim(), ts);
            const { discountCodeID, displayName, discountAmount } = result.data;

            setDiscountcodes((prev) => [...prev, { id: discountCodeID, displayName, amount: discountAmount }]);

            const newSubTotal = totals.subTotal - discountAmount;
            const newTotal = newSubTotal + totals.tax;
            const newFinalPaymentDueAmount = newTotal - totals.amountPaid;

            setTotals((prev) => ({
                ...prev,
                subTotal: newSubTotal,
                total: newTotal,
                finalPaymentDueAmount: newFinalPaymentDueAmount,
            }));

            if (filterByType === 'payBalanceDue') {
                setPaymentAmount(Math.max(0, newFinalPaymentDueAmount));
            }

            setDiscountInput('');
            Swal.fire({ title: 'Discount Applied', text: result.data.message, icon: 'success' });
        } catch (err) {
            const message = err?.response?.data?.message || 'Failed to apply discount code';
            Swal.fire({ title: 'Error', text: message, icon: 'error' });
        } finally {
            setApplyingDiscount(false);
        }
    };

    const calculateSurchargeAmount = (payment) => {
        return roundTo(payment * (totals.surchargePercentage / 100), 2);
    };

    const handlePaymentRadioChange = (type) => {
        switch (type) {
            case 'payDeposit':
                setPaymentAmount(totals.depositAmount);
                break;
            case 'payBalanceDue':
                setPaymentAmount(totals.finalPaymentDueAmount);
                break;
            default:
                break;
        }
        setFilterByType(type);
    };

    const handleOtherAmountChange = (e) => {
        setPaymentAmount(Number(e.target.value));
    };

    const handleSubmitPayment = async (e, token = null) => {
        if (e) e.preventDefault();
        await handleSubmit(async (data) => {
            let chargeAttempted = false;
            try {
                setLoading(true);
                const arr = [];
                if (!data.firstName) arr.push('firstName');
                if (!data.lastName) arr.push('lastName');
                if (!data.email) arr.push('email');
                if (!data.street) arr.push('street');
                if (!data.city) arr.push('city');
                if (!data.state) arr.push('state');
                if (!data.zip) arr.push('zip');
                if (tripSetting?.paymentProcessorTypeID === 3 && !fiservHostedFieldsActive) {
                    if (!data.cardExpiration) arr.push('cardExpiration');
                    if (!data.cardNumber) arr.push('cardNumber');
                    if (!data.cvv) arr.push('cvv');
                }
                if (filterByType === 'payOtherAmount' && !paymentAmount) {
                    arr.push('otherAmount');
                }
                if (filterByType === 'payOtherAmount' && Number(paymentAmount) > totals.finalPaymentDueAmount) {
                    arr.push('Overpayment');
                    Swal.fire({
                        title: 'Overpayment',
                        text: 'You are attempting to pay more than what is owed. Please adjust your payment amount accordingly before submitting payment.',
                        icon: 'warning',
                    });
                }
                setError([...arr]);

                if (!arr.length) {
                    const fiservCard = fiservHostedFieldsActive ? await fiservFieldRef.current.getToken() : null;
                    if (fiservCard && !fiservCard.token) {
                        setLoading(false);
                        return Swal.fire({ title: 'Card Details Required', text: fiservCard.message, icon: 'error' });
                    }

                    if (data && data.cardNumber && data.cardNumber.length < 15) {
                        setLoading(false);
                        return Swal.fire({
                            title: 'Card Number Error',
                            text: 'Please enter a valid Card Number',
                            icon: 'error',
                        });
                    }

                    const basePaymentAmount = Number(paymentAmount);
                    const surchargeAmount = calculateSurchargeAmount(paymentAmount);
                    const amountToPay = String(roundTo(basePaymentAmount + Number(surchargeAmount), 2));

                    let transactionData = {
                        ...data,
                        bookingID: bookingId,
                        companyID: bookingDetails.companyId,
                        surchargeAmount: surchargeAmount,
                        transactionTypeID: 3,
                        userID: user && user.id ? user.id : null,
                        date: moment().format('YYYY-MM-DD'),
                    };

                    if (!amountToPay || amountToPay <= 0) {
                        Swal.fire({
                            title: 'Invalid Payment Amount',
                            text: 'Please select an amount to pay that is greater than $0.00',
                            icon: 'error',
                        });
                    } else {
                        transactionData.amount = amountToPay;
                    }

                    if (Number(roundTo(parseFloat(transactionData.amount), 2)) > Number(amountToPay)) {
                        setLoading(false);
                    } else {
                        let transactionRequest = await createTransactionService(
                            transactionData,
                            bookingDetails.companyId
                        );
                        const {
                            transaction,
                            invoiceFreeEntryRecord = null,
                            surchargeTransaction = null,
                            addonAssignmentRecord = null,
                        } = transactionRequest.data;

                        if (
                            Number(transactionData.transactionTypeID) === 3 ||
                            Number(transactionData.transactionTypeID) === 4
                        ) {
                            const paymentData = {
                                ...transactionData,
                                basePaymentAmount: basePaymentAmount,
                                companyID: transaction.companyID,
                                orderID: transaction.id,
                            };

                            if (token) paymentData.token = token;
                            // The tokenizer returns a CardSecure token in place of the PAN; Fiserv takes it in the same field
                            if (fiservCard) paymentData.cardNumber = fiservCard.token;

                            if (invoiceFreeEntryRecord)
                                paymentData.invoiceFreeEntryRecordID = invoiceFreeEntryRecord.id;
                            if (surchargeTransaction) paymentData.surchargeTransactionID = surchargeTransaction.id;
                            if (addonAssignmentRecord) paymentData.addonAssignmentRecordID = addonAssignmentRecord.id;

                            chargeAttempted = true;
                            let response = await makeBookingPortalPaymentService(paymentData, paymentData.companyID);

                            const paymentResponse = response.data;
                            if (typeof paymentResponse == 'undefined') {
                                Swal.fire({
                                    title: 'Transaction Failed',
                                    text: "We're Sorry. We have experienced an unknown error. Please wait a few minutes and try again. If the issue persists, please get in touch with us.",
                                    icon: 'error',
                                });
                                setLoading(false);
                                return;
                            } else if (paymentResponse.errors && paymentResponse.errors.length > 0) {
                                Swal.fire({
                                    title: 'Transaction Declined',
                                    text: paymentResponse.errors[0].msg,
                                    icon: 'error',
                                });
                                setLoading(false);
                                return;
                            } else if (paymentResponse.error) {
                                Swal.fire({
                                    title: 'Transaction Declined',
                                    text: paymentResponse.error,
                                    icon: 'error',
                                });
                                setLoading(false);
                                return;
                            } else if (paymentResponse.Result === 'Declined') {
                                Swal.fire({
                                    title: 'Transaction Declined',
                                    text: paymentResponse.Status,
                                    icon: 'error',
                                });
                                setLoading(false);
                                return;
                            } else if (paymentResponse.code === 'A') {
                                setFormState({
                                    ...formState,
                                    stage: 2,
                                    id: transaction.id,
                                    amount: paymentResponse.amountCharged,
                                    surchargeRemoved: paymentResponse?.surchargeRemoved,
                                });
                            }
                        }
                    }
                }
                setLoading(false);
            } catch (e) {
                if (e.response?.data?.errors?.length) {
                    const normalized = normalizePaymentError(e);
                    await errorSwal({
                        title: 'Payment Failed',
                        text:
                            normalized.message || 'An error occurred while processing your payment. Please try again.',
                    });
                    // // Only reload on Payroc to refresh hosted fields session
                    if (tripSetting?.paymentProcessorTypeID === 5) {
                        window.location.reload();
                    }
                } else {
                    errorSwal({
                        title: 'Payment Failed',
                        text: 'An unexpected error occurred while processing your payment. Please try again.',
                    });
                }
            } finally {
                if (chargeAttempted && fiservHostedFieldsActive) resetFiservCard();
                setLoading(false);
            }
        })();
    };

    const handleShowPaymentModal = (e) => {
        e.preventDefault();
        handleSubmit(async (data) => {
            try {
                const arr = [];
                if (!data.firstName) arr.push('firstName');
                if (!data.lastName) arr.push('lastName');
                if (!data.email) arr.push('email');
                if (!data.street) arr.push('street');
                if (!data.city) arr.push('city');
                if (!data.state) arr.push('state');
                if (!data.zip) arr.push('zip');
                if (filterByType === 'payOtherAmount' && !paymentAmount) {
                    arr.push('otherAmount');
                }
                if (filterByType === 'payOtherAmount' && Number(paymentAmount) > totals.finalPaymentDueAmount) {
                    arr.push('Overpayment');
                    Swal.fire({
                        title: 'Overpayment',
                        text: 'You are attempting to pay more than what is owed. Please adjust your payment amount accordingly before submitting payment.',
                        icon: 'warning',
                    });
                }
                setError([...arr]);

                if (!arr.length) {
                    setShowPaymentModal(true);
                }
            } catch (e) {
                console.log(e);
            }
        })();
    };

    const paymentForms = () => {
        return (
            <Row>
                <Col md={8} xs={12} className="d-flex justify-content-center">
                    <div className="w-100 payment-form-main">
                        <form className="payment-form-wrapper">
                            <Form.Label
                                className=" text-uppercase payment-form-headding"
                                style={{ color: `${tripSetting.textColor}` }}
                            >
                                Billing Information
                            </Form.Label>
                            <div
                                className="payment-form-desc-main"
                                style={{ backgroundColor: `${tripSetting.mainColor}` }}
                            >
                                <Row>
                                    <Col xs={12}>
                                        <FormGroup className="d-flex payment-form-group">
                                            <Form.Label
                                                className="payment-form-label"
                                                style={{ color: `${tripSetting.textColor}` }}
                                            >
                                                NAME*
                                            </Form.Label>
                                            <div className="d-flex flex-column payment-form-input-group w-100">
                                                <Form.Control
                                                    type="text"
                                                    id="firstName"
                                                    name="firstName"
                                                    placeholder="First Name"
                                                    {...register('firstName')}
                                                    isInvalid={errors.includes('firstName')}
                                                    className="payment-form-input"
                                                />
                                                <FormControl.Feedback id="description" type="invalid">
                                                    First Name is required
                                                </FormControl.Feedback>

                                                <Form.Control
                                                    type="text"
                                                    id="lastName"
                                                    name="lastName"
                                                    placeholder="Last Name"
                                                    {...register('lastName')}
                                                    isInvalid={errors.includes('lastName')}
                                                    className="payment-form-input"
                                                />
                                                <FormControl.Feedback id="description" type="invalid">
                                                    Last Name is required
                                                </FormControl.Feedback>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12}>
                                        <FormGroup className="d-flex payment-form-group">
                                            <Form.Label
                                                className="payment-form-label"
                                                style={{ color: `${tripSetting.textColor}` }}
                                            >
                                                COMPANY
                                            </Form.Label>
                                            <div className="d-flex flex-column payment-form-input-group w-100">
                                                <Form.Control
                                                    type="text"
                                                    id="company"
                                                    name="company"
                                                    placeholder="Company/Organization"
                                                    {...register('company')}
                                                    className="payment-form-input"
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12}>
                                        <FormGroup className="d-flex payment-form-group">
                                            <Form.Label
                                                className="payment-form-label"
                                                style={{ color: `${tripSetting.textColor}` }}
                                            >
                                                EMAIL*
                                            </Form.Label>
                                            <div className="d-flex flex-column payment-form-input-group w-100">
                                                <Form.Control
                                                    type="text"
                                                    id="email"
                                                    name="email"
                                                    placeholder="Email"
                                                    {...register('email')}
                                                    isInvalid={errors.includes('email')}
                                                    className="payment-form-input"
                                                />
                                                <FormControl.Feedback id="description" type="invalid">
                                                    Email is required
                                                </FormControl.Feedback>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12}>
                                        <FormGroup className="d-flex payment-form-group">
                                            <Form.Label
                                                className="payment-form-label"
                                                style={{ color: `${tripSetting.textColor}` }}
                                            >
                                                BILLING ADDRESS*
                                            </Form.Label>
                                            <div className="d-flex flex-column payment-form-input-group w-100">
                                                <Form.Control
                                                    type="text"
                                                    id="street"
                                                    name="street"
                                                    required={true}
                                                    placeholder="Address Line 1"
                                                    {...register('street')}
                                                    isInvalid={errors.includes('street')}
                                                    className="payment-form-input"
                                                />
                                                <FormControl.Feedback id="description" type="invalid">
                                                    Street Address is required
                                                </FormControl.Feedback>

                                                <Form.Control
                                                    type="text"
                                                    id="street2"
                                                    name="street2"
                                                    placeholder="Address Line 2"
                                                    {...register('street2')}
                                                    className="payment-form-input"
                                                />
                                                <Form.Control
                                                    type="text"
                                                    id="city"
                                                    name="city"
                                                    required={true}
                                                    placeholder="City"
                                                    {...register('city')}
                                                    isInvalid={errors.includes('city')}
                                                    className="payment-form-input"
                                                />
                                                <FormControl.Feedback id="description" type="invalid">
                                                    City is required
                                                </FormControl.Feedback>

                                                <div className="d-flex payment-form-select-group">
                                                    <Form.Control
                                                        as="select"
                                                        id="state"
                                                        name="state"
                                                        placeholder="State"
                                                        className="payment-form-select"
                                                        {...register('state')}
                                                        isInvalid={errors.includes('state')}
                                                    >
                                                        {states.length &&
                                                            states.map((r, i) => (
                                                                <option key={i} value={r.abbreviation}>
                                                                    {r.abbreviation}
                                                                </option>
                                                            ))}
                                                    </Form.Control>
                                                    <FormControl.Feedback id="description" type="invalid">
                                                        State is required
                                                    </FormControl.Feedback>

                                                    <Form.Control
                                                        type="text"
                                                        id="zip"
                                                        name="zip"
                                                        required={true}
                                                        placeholder="Zip"
                                                        {...register('zip')}
                                                        isInvalid={errors.includes('zip')}
                                                        className="payment-form-select"
                                                    />
                                                    <FormControl.Feedback id="description" type="invalid">
                                                        Zip Name is required
                                                    </FormControl.Feedback>

                                                    <Form.Control
                                                        as="select"
                                                        id="country"
                                                        name="country"
                                                        className="payment-form-select"
                                                        placeholder="country"
                                                        {...register('country')}
                                                    >
                                                        {countries &&
                                                            countries.length > 0 &&
                                                            countries.map((r, i) => (
                                                                <option key={i} value={r.alpha2Code}>
                                                                    {r.name}
                                                                </option>
                                                            ))}
                                                    </Form.Control>
                                                </div>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            {!(totals.amountPaid >= totals.total) && tripSetting?.paymentProcessorTypeID !== 5 ? (
                                <>
                                    <Form.Label
                                        className=" text-uppercase payment-form-headding"
                                        style={{ color: `${tripSetting.textColor}` }}
                                    >
                                        Payment Information
                                    </Form.Label>
                                    <div
                                        className="payment-form-desc-main"
                                        style={{ backgroundColor: `${tripSetting.mainColor}` }}
                                    >
                                        <Row>
                                            <Col xs={3}>
                                                <Form.Label
                                                    className="payment-form-label"
                                                    style={{ color: `${tripSetting.textColor}` }}
                                                >
                                                    CREDIT CARD*
                                                </Form.Label>
                                            </Col>
                                            <Col xs={9}>
                                                {fiservHostedFieldsActive ? (
                                                    <FiservCardNumberField
                                                        key={fiservFieldKey}
                                                        ref={fiservFieldRef}
                                                        onTokenReceived={setFiservToken}
                                                        onErrorReceived={setFiservError}
                                                        companyID={bookingDetails.companyId}
                                                        panelColor={tripSetting.mainColor || '#383636'}
                                                        textColor={tripSetting.textColor || '#ffffff'}
                                                        showSecurelyCapturedMessage={!!fiservToken}
                                                        errorMessage={fiservError}
                                                    />
                                                ) : (
                                                    <Row>
                                                        <Col xs={12}>
                                                            <FormGroup className="d-flex payment-form-group mb-1">
                                                                <div className="d-flex flex-column payment-form-input-group w-100">
                                                                    <Form.Control
                                                                        type="text"
                                                                        id="cardNumber"
                                                                        name="cardNumber"
                                                                        required={true}
                                                                        maxLength={16}
                                                                        placeholder="Card Number*"
                                                                        {...(tripSetting?.paymentProcessorTypeID === 3
                                                                            ? register('cardNumber', {
                                                                                  required:
                                                                                      'Please Enter a Card Number',
                                                                              })
                                                                            : { ref: register })}
                                                                        isInvalid={errors.includes('cardNumber')}
                                                                        className="payment-form-input"
                                                                    />
                                                                    <FormControl.Feedback
                                                                        id="description"
                                                                        type="invalid"
                                                                    >
                                                                        Please Enter a Card Number
                                                                    </FormControl.Feedback>
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col xs={12}>
                                                            <div className="d-flex justify-content-between mb-3">
                                                                <div className="w-100">
                                                                    <Form.Control
                                                                        type="text"
                                                                        id="cardExpiration"
                                                                        name="cardExpiration"
                                                                        required={true}
                                                                        placeholder="Expiration Date* (MMYY)"
                                                                        maxLength={4}
                                                                        {...(tripSetting?.paymentProcessorTypeID === 3
                                                                            ? register('cardExpiration', {
                                                                                  required:
                                                                                      'Please Enter a Card Expiration',
                                                                              })
                                                                            : { ref: register })}
                                                                        isInvalid={errors.includes('cardExpiration')}
                                                                        className="form-sub-input"
                                                                    />
                                                                    <FormControl.Feedback
                                                                        id="description"
                                                                        type="invalid"
                                                                    >
                                                                        Card Expiration Date is required
                                                                    </FormControl.Feedback>
                                                                </div>

                                                                <div className="pl-1">
                                                                    <Form.Control
                                                                        type="text"
                                                                        id="cvv"
                                                                        name="cvv"
                                                                        required={true}
                                                                        placeholder="CVV*"
                                                                        maxLength={4}
                                                                        {...(tripSetting?.paymentProcessorTypeID === 3
                                                                            ? register('cvv', {
                                                                                  required: 'Please Enter a CVV',
                                                                              })
                                                                            : { ref: register })}
                                                                        isInvalid={errors.includes('cvv')}
                                                                        className="form-cvv-input"
                                                                    />
                                                                    <FormControl.Feedback
                                                                        id="description"
                                                                        type="invalid"
                                                                    >
                                                                        CVV is required
                                                                    </FormControl.Feedback>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </Col>
                                            {!tripSetting.hideApplyDiscountCodeButton && (
                                                <>
                                                    <Col xs={3}></Col>
                                                    <Col xs={9}>
                                                        <FormGroup className="d-flex payment-form-group">
                                                            <div className="d-flex flex-row align-items-center payment-form-disscount w-100">
                                                                <Form.Control
                                                                    type="text"
                                                                    id="discountCode"
                                                                    name="discountCode"
                                                                    placeholder="Discount Code"
                                                                    value={discountInput}
                                                                    onChange={(e) => setDiscountInput(e.target.value)}
                                                                    className="payment-form-input"
                                                                />
                                                                <Button
                                                                    disabled={
                                                                        applyingDiscount ||
                                                                        discountInput.trim().length == 0
                                                                    }
                                                                    onClick={handleApplyDiscountCode}
                                                                    style={{
                                                                        backgroundColor: tripSetting.buttonColor,
                                                                        borderColor: 'transparent',
                                                                        whiteSpace: 'nowrap',
                                                                        marginLeft: '8px',
                                                                    }}
                                                                >
                                                                    {applyingDiscount ? 'Applying...' : 'Apply'}
                                                                </Button>
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                </>
                                            )}
                                        </Row>
                                    </div>
                                </>
                            ) : null}
                            {!(totals.amountPaid >= totals.total) &&
                                tripSetting?.paymentProcessorTypeID === 5 &&
                                !tripSetting.hideApplyDiscountCodeButton && (
                                    <>
                                        <Form.Label
                                            className="text-uppercase payment-form-headding"
                                            style={{ color: `${tripSetting.textColor}` }}
                                        >
                                            Discount Code
                                        </Form.Label>
                                        <div
                                            className="payment-form-desc-main"
                                            style={{ backgroundColor: `${tripSetting.mainColor}` }}
                                        >
                                            <Row>
                                                <Col xs={12}>
                                                    <FormGroup className="d-flex payment-form-group">
                                                        <div className="d-flex flex-row align-items-center payment-form-disscount w-100">
                                                            <Form.Control
                                                                type="text"
                                                                id="discountCode"
                                                                name="discountCode"
                                                                placeholder="Discount Code"
                                                                value={discountInput}
                                                                onChange={(e) => setDiscountInput(e.target.value)}
                                                                className="payment-form-input"
                                                            />
                                                            <Button
                                                                disabled={
                                                                    applyingDiscount || discountInput.trim().length == 0
                                                                }
                                                                onClick={handleApplyDiscountCode}
                                                                style={{
                                                                    backgroundColor: tripSetting.buttonColor,
                                                                    borderColor: 'transparent',
                                                                    whiteSpace: 'nowrap',
                                                                    marginLeft: '8px',
                                                                }}
                                                            >
                                                                {applyingDiscount ? 'Applying...' : 'Apply'}
                                                            </Button>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    </>
                                )}
                            <div>
                                <p className="payment-form-required-title portal-text mt-2">*Field Required</p>
                            </div>
                        </form>
                    </div>
                </Col>
                <Col md={4} xs={12} className="d-flex flex-column justify-content-between bokking-details-main">
                    <h3 className="booking-details-headding">
                        BOOKING {bookingID}
                        {!!bookingDetails.purchaseOrder && (
                            <h6 className="mt-4">PO NUMBER: {bookingDetails.purchaseOrder}</h6>
                        )}
                    </h3>
                    <div
                        className="light-gray-bg booking-details-wrapper"
                        style={{ backgroundColor: `${tripSetting.mainColor}` }}
                    >
                        {bookingDetails.documentTypeID == 1 && addonAssignments && addonAssignments.length > 0 && (
                            <>
                                <div className="booking-wrap">
                                    {vehicles &&
                                        vehicles.map((vehicle, i) => {
                                            return (
                                                <ListVehicles
                                                    key={i}
                                                    quantity={vehicle.count}
                                                    description={vehicle.vehicleType}
                                                    price={vehicle.price}
                                                    tripSetting={tripSetting}
                                                />
                                            );
                                        })}
                                </div>
                                <div className="booking-wrap">
                                    <p className="booking-desc" style={{ color: `${tripSetting.textColor}` }}>
                                        ADD ONS & EXTRAS
                                    </p>
                                    {addonAssignments.map((addon, i) => {
                                        return (
                                            <ListAddons
                                                key={i}
                                                quantity={addon.quantity}
                                                priceTypeId={addon.priceTypeId}
                                                description={addon.description}
                                                price={addon.price}
                                                tripSetting={tripSetting}
                                            />
                                        );
                                    })}
                                </div>
                            </>
                        )}
                        {discountCodes && discountCodes.length > 0 && (
                            <div className="booking-wrap">
                                <p className="booking-desc" style={{ color: `${tripSetting.textColor}` }}>
                                    DISCOUNT CODE
                                </p>
                                {discountCodes &&
                                    discountCodes.map((code) => {
                                        return code.amount > 0 ? (
                                            <ListDiscountCodes
                                                key={code.id}
                                                displayName={code.displayName}
                                                amount={code.amount}
                                                tripSetting={tripSetting}
                                            />
                                        ) : (
                                            ''
                                        );
                                    })}
                            </div>
                        )}
                        <div className="booking-total">
                            <div className="d-flex align-items-center justify-content-between total-wrapper">
                                <span className="total-text">SUBTOTAL:</span>
                                <span className="total-amt">{`$${formatCurrency(totals.subTotal)}`}</span>
                            </div>
                            <div className="d-flex align-items-center justify-content-between total-wrapper">
                                <span className="total-text">TAX:</span>
                                <span className="total-amt">{`$${formatCurrency(totals.tax)}`}</span>
                            </div>
                            <div className="d-flex align-items-center justify-content-between total-wrapper">
                                <span className="total-text">TOTAL:</span>
                                <span className="total-amt">{`$${formatCurrency(totals.total)}`}</span>
                            </div>
                            <div className="d-flex align-items-center justify-content-between total-wrapper">
                                <span className="total-text">PAID:</span>
                                <span className="total-amt">{`$${formatCurrency(totals.amountPaid)}`}</span>
                            </div>
                        </div>
                    </div>
                    <div className="booking-deatils-box" style={{ backgroundColor: `${tripSetting.mainColor}` }}>
                        <div className="row">
                            <div className="w-100">
                                <div
                                    style={{
                                        display: `${totals.amountPaid < totals.depositAmount ? 'flex' : 'none'}`,
                                        justifyContent: 'space-between',
                                        padding: '12px',
                                    }}
                                >
                                    {totals.amountPaid < totals.depositAmount ? (
                                        <p className="deposite-text-title portal-text  h6 mb-0 text-uppercase">
                                            <span className="deposite-text portal-text">DEPOSIT DUE:</span>
                                            <span className="deposite-date-title portal-text">
                                                {' '}
                                                {totals.depositDue ? `DUE ON OR BEFORE ${totals.depositDue} ` : ''}
                                            </span>
                                        </p>
                                    ) : (
                                        ''
                                    )}
                                    {totals.amountPaid < totals.depositAmount ? (
                                        <p className="form-text-first portal-text font-weight-bold h6 mb-0 text-uppercase">
                                            {`$${
                                                totals.depositDueAmount > 0
                                                    ? formatCurrency(totals.depositDueAmount)
                                                    : 0.0
                                            }`}
                                        </p>
                                    ) : (
                                        ''
                                    )}
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px' }}>
                                    {!(totals.amountPaid >= totals.total) ? (
                                        <p className="deposite-text-title portal-text font-weight-bold h6 mb-0 mt-2 text-uppercase">
                                            <span
                                                className="balance-text"
                                                style={{ color: `${tripSetting.textColor}` }}
                                            >
                                                BALANCE DUE:
                                            </span>
                                            <span className="deposite-date-title portal-text mb-2">
                                                {' '}
                                                {totals.finalPaymentDue
                                                    ? `DUE ON OR BEFORE ${totals.finalPaymentDue}`
                                                    : ''}{' '}
                                            </span>
                                        </p>
                                    ) : (
                                        ''
                                    )}
                                    {!(totals.amountPaid >= totals.total) ? (
                                        <p
                                            className="form-text-box font-weight-bold h6 mb-0 text-uppercase"
                                            style={{ color: `${tripSetting.textColor}`, paddingTop: '6px' }}
                                        >
                                            {`$${
                                                totals.finalPaymentDueAmount > 0
                                                    ? formatCurrency(totals.finalPaymentDueAmount)
                                                    : 0.0
                                            }`}
                                        </p>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="form-leftside">
                                    <div className="radio-button-group">
                                        {!(totals.amountPaid >= totals.depositAmount) ? (
                                            <Form.Check
                                                className="balance-radio"
                                                label="PAY DEPOSIT"
                                                name="payDeposit"
                                                type="radio"
                                                id="payDeposit"
                                                checked={filterByType === 'payDeposit'}
                                                onChange={() => handlePaymentRadioChange('payDeposit')}
                                            />
                                        ) : (
                                            ''
                                        )}
                                        {!(totals.amountPaid >= totals.total) ? (
                                            <Form.Check
                                                className="balance-radio"
                                                label="PAY BALANCE DUE"
                                                name="payBalanceDue"
                                                type="radio"
                                                id="payBalanceDue"
                                                checked={filterByType === 'payBalanceDue'}
                                                onChange={() => handlePaymentRadioChange('payBalanceDue')}
                                            />
                                        ) : (
                                            ''
                                        )}
                                        <Form.Check
                                            className="balance-radio"
                                            label="PAY OTHER AMOUNT"
                                            name="payOtherAmount"
                                            type="radio"
                                            id="payOtherAmount"
                                            checked={filterByType === 'payOtherAmount'}
                                            onChange={() => handlePaymentRadioChange('payOtherAmount')}
                                        />
                                    </div>

                                    <div className="radio-button-form ">
                                        <FormGroup className="mb-0">
                                            <Form.Control
                                                onChange={handleOtherAmountChange}
                                                type="number"
                                                name="otherAmount"
                                                placeholder="Enter $ Amount"
                                                disabled={
                                                    filterByType === 'payBalanceDue' || filterByType === 'payDeposit'
                                                }
                                                value={
                                                    filterByType === 'payOtherAmount' &&
                                                    (paymentAmount || paymentAmount === 0)
                                                        ? paymentAmount
                                                        : ''
                                                }
                                                key="otherAmount"
                                                isInvalid={
                                                    errors.includes('otherAmount') || errors.includes('Overpayment')
                                                }
                                            />
                                            <FormControl.Feedback id="otherAmount" type="invalid">
                                                {errors.includes('otherAmount') ? 'Enter Amount' : 'Overpayment'}
                                            </FormControl.Feedback>
                                        </FormGroup>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <div className="d-flex align-items-center justify-content-between total-wrapper">
                                        <span className="deposite-text portal-text">PAYMENT AMOUNT:</span>
                                        <span className="deposite-date-title portal-text">{`$${formatCurrency(
                                            paymentAmount
                                        )}`}</span>
                                    </div>
                                    {totals.surchargePercentage ? (
                                        <>
                                            <div className="d-flex align-items-center justify-content-between total-wrapper">
                                                <span className="deposite-text portal-text">CC SURCHARGE AMOUNT:</span>
                                                <span className="deposite-date-title portal-text">{`$${formatCurrency(
                                                    calculateSurchargeAmount(paymentAmount)
                                                )}`}</span>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between total-wrapper">
                                                <span className="deposite-text portal-text">TRANSACTION TOTAL:</span>
                                                <span className="deposite-date-title portal-text">{`$${formatCurrency(
                                                    paymentAmount + calculateSurchargeAmount(paymentAmount)
                                                )}`}</span>
                                            </div>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="button-wrapper mt-3">
                        <div className="button-of-first">
                            <Button
                                className="mb-2"
                                disabled={!bookingId || totals.amountPaid >= totals.total}
                                onClick={
                                    tripSetting.paymentProcessorTypeID === 3
                                        ? handleSubmitPayment
                                        : handleShowPaymentModal
                                }
                                style={{
                                    backgroundColor: `${loading ? '#646262' : tripSetting.buttonColor}`,
                                    borderColor: 'transparent',
                                }}
                            >
                                <i className="fas fa-lock  mr-2 "></i>
                                {tripSetting.paymentProcessorTypeID === 3 ? 'SUBMIT PAYMENT' : 'PROCEED TO PAYMENT'}
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
        );
    };

    const confirmation = () => {
        return (
            <>
                <div className="background-box-wrapper" style={{ backgroundColor: `${tripSetting.sectionColor}` }}>
                    <p className="booking-title portal-text">{`BOOKING ${bookingID}`}</p>
                    <div className="light-gray-bg  w-100 text-center inner-box">
                        <div className="images-logo">
                            <Image src={tripSetting.companyLogoUrl} className="m-0 p-0" />
                        </div>
                        <div className="card-payment-box" style={{ backgroundColor: `${tripSetting.textColor}` }}>
                            <i className="fa fa-credit-card-alt text-dark mx-2" />
                            <span className="payment-title">Payment Success</span>
                        </div>
                        <i className="fa fa-thumbs-up text-dark fa-4x mt-3" />
                        <h3 className="title-processed mb-2 mt-2" style={{ color: `${tripSetting.textColor}` }}>
                            Your Payment has been successfully processed
                        </h3>
                        {formState?.surchargeRemoved && (
                            <div>
                                <p className="mb-0 mt-3">
                                    Since the payment was made with a debit card, no surcharge was processed.
                                </p>
                            </div>
                        )}
                        <p className="mb-0 mt-3">Confirmation Number</p>
                        <h4 className="title-amount mb-2" style={{ color: `${tripSetting.textColor}` }}>
                            {formState.id}
                        </h4>
                        <p className="mb-0 mt-3">Amount Paid</p>
                        <h4
                            className="title-amount mb-5 pb-5"
                            style={{ color: `${tripSetting.textColor}` }}
                        >{`$${formatCurrency(formState.amount)}`}</h4>
                    </div>
                </div>
            </>
        );
    };

    const handleprint = async () => {
        try {
            setLoading(true);
            const pdfData = await printSignedBookingService(bookingId, contarctId, bookingDetails.companyId, user);
            setLoading(false);
            let blob = new Blob([pdfData.data], { type: 'application/pdf' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            link.download = 'Booking (' + bookingDetails.bookingId + ')';
            link.click();
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };

    return !initialLoading && tripSetting && isFiservHostedFieldsEnabled !== null ? (
        <div>
            <>
                <div className="top-header">
                    <div
                        className="top-header-box d-flex justify-content-between align-items-center"
                        style={{ backgroundColor: `${tripSetting.sectionColor}` }}
                    >
                        <div className="booking-title portal-text">
                            {tripSetting && tripSetting.companyLogoUrl ? (
                                <Image src={tripSetting.companyLogoUrl} className="images-logo m-0 p-0" />
                            ) : (
                                ''
                            )}
                            <div className="booking-heading">{`BOOKING ${bookingID}`}</div>
                        </div>
                        <div className="button-head">
                            {!contarctId ? (
                                <Button
                                    className="portal-text no-point"
                                    style={{
                                        backgroundColor: `${loading ? '#646262' : tripSetting.buttonColor}`,
                                        borderColor: 'transparent',
                                    }}
                                >
                                    <i className="fas fa-check-square mr-2"></i>BOOKING PAYMENTS
                                </Button>
                            ) : (
                                <Button
                                    className="btn-primary ml-2"
                                    style={{
                                        backgroundColor: `${loading ? '#646262' : tripSetting.buttonColor}`,
                                        borderColor: 'transparent',
                                    }}
                                    onClick={handleprint}
                                >
                                    VIEW SIGNED CONFIRMATION
                                </Button>
                            )}
                        </div>
                    </div>
                    <div className="background-box-color p-3">
                        <div className="background-wrapper" style={{ backgroundColor: `${tripSetting.sectionColor}` }}>
                            <Container fluid>
                                {Number(formState.stage) === 2 ? confirmation() : paymentForms()}
                            </Container>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-end p-4">
                    <Image
                        src={'https://storage.googleapis.com/the-bus-network-bucket/default/Powered-By-TBN-Logo.png'}
                        className="m-0 p-0"
                    />
                </div>
                <PayrocPaymentModal
                    show={showPaymentModal}
                    onHide={() => setShowPaymentModal(false)}
                    tripSetting={tripSetting}
                    handleSubmitPayment={handleSubmitPayment}
                    companyId={bookingDetails.companyId}
                />
            </>
            {loading && <Loading loading={loading} />}
        </div>
    ) : (
        <Loading loading={loading} />
    );
};

export default React.memo(BookingTransaction, () => true);
